import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { CadastroComponent } from './pages/cadastro/cadastro.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AgendamentoComponent } from './pages/agendamento/agendamento.component';
import { EsqueciComponent } from './pages/esqueci/esqueci.component';
import { SenhaComponent } from './pages/senha/senha.component';
import { AuthGuard } from './guard/auth.guard';
import { ServicoComponent } from './pages/servico/servico.component';
import { PagamentoComponent } from './pages/pagamento/pagamento.component';
import { LoginEmpresaComponent } from './pages/login-empresa/login-empresa.component';
import { CadastroEmpresaComponent } from './pages/cadastro-empresa/cadastro-empresa.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'login/empresa', component: LoginEmpresaComponent, pathMatch: 'full' },
  { path: 'esqueci', component: EsqueciComponent, pathMatch: 'full' },
  { path: 'senha', component: SenhaComponent, pathMatch: 'full' },
  { path: 'cadastro', component: CadastroComponent, pathMatch: 'full' },
  { path: 'cadastro/empresa', component: CadastroEmpresaComponent, pathMatch: 'full' },
  { path: 'app/servico', component: ServicoComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'app/dashboard', component: DashboardComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'app/agendamento/edit', component: AgendamentoComponent,  canActivate: [AuthGuard], pathMatch: 'full', data: { type: 'edit' } },
  { path: 'app/agendamento/novo', component: AgendamentoComponent,  canActivate: [AuthGuard], pathMatch: 'full', data: { type: 'add' } },
  { path: 'app/pagamento', component: PagamentoComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: '**', redirectTo: 'login'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
